module.exports = __webpack_public_path__ + "static/media/15_thedevil.d5f690b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/15_thedevil.png
// module id = 78
// module chunks = 0